// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";

import Header from "./Components/Header";
import Home from "./Components/Home";
import Footer from "./Components/Footer";
import { Route, Routes } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import TermsAndConditions from "./Components/Pages/Terms&Conditions";
import PrivacyAndPolicy from "./Components/Pages/PrivacyAndPolicy";
import Contact from "./Components/Pages/Contact";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyAndPolicy />} />
        <Route path="/contact-us" element={<Contact />} />
      </Routes>

      <Footer />

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <a href="tel:+916367607678" className="call-button">
              <FaPhoneAlt />
              <span className="call-number">+91-6367607678</span>
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=916367607678&text=My car has broken down, please send help 🙏"
              className="btn-whatsapp-pulse btn-whatsapp-pulse-border"
            >
              <FaWhatsapp color="white" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
